import * as Yup from "yup";

const precio = Yup.string()
  .trim()
  .required("Precio requerido")
  .matches(/^\d+(\.\d{1,2})?$/, "Solo números");

export const FormSeccionScheme = () => {
  return Yup.object().shape({
    nombre: Yup.string()
      .required("El campo es requerido")
      .trim()
      .max(60, "Máximo 60 caracteres"),
    eyebrow: Yup.string().trim().max(40, "Máximo 40 caracteres"),
    navLabel: Yup.string().trim().max(30, "Máximo 30 caracteres"),
    itemsTitulo: Yup.string().trim().max(60, "Máximo 60 caracteres"),
    precios: Yup.array().of(
      Yup.object().shape({
        etiqueta: Yup.string().trim().required("Etiqueta requerida"),
        detalle: Yup.string().trim(),
        precio,
      })
    ),
    extrasOpciones: Yup.array().when("extrasActivo", {
      is: true,
      then: (s) =>
        s.of(
          Yup.object().shape({
            etiqueta: Yup.string().trim().required("Etiqueta requerida"),
            precio,
          })
        ),
    }),
    imagenes: Yup.array().of(
      Yup.object().shape({
        src: Yup.string()
          .trim()
          .required("URL requerida")
          .matches(/^(https:\/\/|\/)/, "Debe iniciar con https:// o /"),
        caption: Yup.string().trim(),
      })
    ),
  });
};
